import Spinner from './spinner.vue'
import Ring from './ring.vue'
import MiniSpinner from './mini-spinner.vue'
import LineWave from './line-wave.vue'
import LineScale from './line-scale.vue'
import LineDown from './line-down.vue'
import BarFade from './bar-fade.vue'
import BarFadeScale from './bar-fade-scale.vue'

export default {
  Spinner,
  Ring,
  MiniSpinner,
  LineWave,
  LineScale,
  LineDown,
  BarFade,
  BarFadeScale
}
